import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Icon, Dropdown } from 'semantic-ui-react';
import find from 'lodash/find';
import result from 'lodash/result';
import { CANCELLED_PURCHASE_STATUS } from '../../constants';
import { dateTimeCell } from '../../utilities/dateUtils';

const currencyProps = price => ({
  currency: 'USD',
  style: 'currency',
  minimumFractionDigits: 0,
  value: price,
});

const booleanCell = value => (value ? (
  <Icon color='green' name='checkmark' size='large' />
) : (
  <Icon color='red' name='close' size='large' />
));

const ListRowV2 = actionHandler => cancelledPurchase => {
  const {
    externalId,
    status,
    guaranteeStatus,
    buyerEmail,
    auctionAccessNo,
    dealerNo,
    vin,
    universalNo,
    guaranteeDaysSelected,
    guaranteeMilesSelected,
    guaranteeIfBid,
    guaranteeSellerPaid,
    automaticPurchase,
    salePrice,
    guaranteePrice,
    inspectionPrice,
    cancellingUserName,
    cancellationDate,
    cancellationReason,
  } = cancelledPurchase;

  const rowMenuOptions = [
    {
      key: 1,
      text: 'Reinstate Guarantee',
      value: 'Reinstate Guarantee',
      disabled: guaranteeStatus === 'reinstating',
    },
    {
      key: 2,
      text: 'Status History',
      value: 'Status History',
    },
  ];

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, cancelledPurchase);
  };

  return (
    <Table.Row key={externalId} data-testid='purchase-row'>
      <Table.Cell>{buyerEmail}</Table.Cell>
      <Table.Cell>{auctionAccessNo}</Table.Cell>
      <Table.Cell>{dealerNo}</Table.Cell>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{universalNo}</Table.Cell>
      <Table.Cell data-testid='days-selected-cell'>
        {guaranteeDaysSelected}
      </Table.Cell>
      <Table.Cell data-testid='miles-selected-cell'>
        {guaranteeMilesSelected}
      </Table.Cell>
      <Table.Cell textAlign='center' data-testid='if-bid-cell'>
        {booleanCell(guaranteeIfBid)}
      </Table.Cell>
      <Table.Cell textAlign='center' data-testid='seller-paid-cell'>
        {booleanCell(guaranteeSellerPaid)}
      </Table.Cell>
      <Table.Cell textAlign='center' data-testid='automatic-purchase-cell'>
        {booleanCell(automaticPurchase)}
      </Table.Cell>
      <Table.Cell>
        {salePrice != null
          && React.createElement(FormattedNumber, currencyProps(salePrice))}
      </Table.Cell>
      <Table.Cell>
        {guaranteePrice != null
          && React.createElement(FormattedNumber, currencyProps(guaranteePrice))}
      </Table.Cell>
      <Table.Cell data-testid='status-cell'>
        {result(
          find(CANCELLED_PURCHASE_STATUS, ['value', guaranteeStatus]),
          'text'
        ) || guaranteeStatus}
      </Table.Cell>
      <Table.Cell data-testid='api-status-cell'>{status}</Table.Cell>
      <Table.Cell>
        {inspectionPrice != null
          && React.createElement(FormattedNumber, currencyProps(inspectionPrice))}
      </Table.Cell>
      <Table.Cell>{cancellingUserName}</Table.Cell>
      <Table.Cell data-testid='cancellation-date-cell'>
        {dateTimeCell(cancellationDate)}
      </Table.Cell>
      <Table.Cell>{cancellationReason}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRowV2;
